/* tslint:disable:max-line-length */
import { defineMessages, MessageDescriptor } from 'react-intl';

export const messages: Record<string, MessageDescriptor> = defineMessages({
  defaultError: {
    defaultMessage: "We're sorry, an error has occurred",
    id: 'Error.defaultMessage',
  },
  INVALID_STATE_CREDENTIALS_IS_AWAITING_THIRD_PARTY: {
    defaultMessage:
      'Your previously started bank session was not completed. Please wait a few minutes and then try again.',
    id: 'INVALID_STATE_CREDENTIALS_IS_AWAITING_THIRD_PARTY',
  },
});
